// src/components/Modal.js
import React, { useState } from 'react';
import '../styles/Modal.css';

const Modal = ({ isOpen, onClose, title, message, buttons, inputConfig, icon }) => {
  const [inputValue, setInputValue] = useState('');

  if (!isOpen) return null;

  const handleButtonClick = (action) => {
    action(inputValue);
    onClose();
    setInputValue('');
  };

  console.log('Modal icon prop:', icon);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {icon && <div className="modal-icon-container">{icon}</div>}
        {title && <h2>{title}</h2>}
        <p>{message}</p>
        {inputConfig && (
          <div className="modal-input">
            <label>{inputConfig.label}</label>
            <input
              type="text"
              placeholder={inputConfig.placeholder}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              className={inputConfig.class || 'input-field'}
            />
          </div>
        )}
        <div className="modal-buttons">
          {buttons.map((btn, index) => (
            <button
              key={index}
              className={btn.class || 'btn'}
              onClick={() => handleButtonClick(btn.action)}
            >
              {btn.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Modal;